<div class="modal-header">
  <h4 class="modal-title text-dark" id="mySmallModalLabel"> {{'Upload VIN Image(s)' }}</h4>
  <button type="button" class="close" data-dismiss="modal" id="closeUpload">×</button>
</div>
<div class="modal-body">
  <!-- File Upload -->
  @if (vinImages.length == 0) {
    <div class="file-upload w-100 p-3">
      <div class="image-upload-wrap p-3 py-5">
        <input class="file-upload-input" type='file' accept=" .jpg, .jpeg, .heic, .heif, .png"
          (change)="organizeVINImage($event)" multiple />
          <div class="text-center">
            <span class="h1 text-muted dripicons-cloud-upload"></span>
            <h3 class="text-muted">Drop VIN image(s) here or click to upload VIN image(s)</h3>
          </div>
        </div>
      </div>
    }
    @if (calledFrom == 'inventoryDetail' && vinImages.length !== 0) {
      <div class="text-center">
        <h2>Please wait, scanning VIN Image....</h2>
      </div>
    }
    <div>
      @if (vinImages.length !== 0 && calledFrom !== 'inventoryDetail') {
        <div class="form-group col-md-4 col-sm-12">
          <label for="inventorySourceId">Inventory Source</label>
          <select id="inventorySourceId" class="form-control form-control-sm text-dark">
            <option></option>
            @for (vendor of vendors; track vendor) {
              <option [value]="vendor.id">
              {{vendor.companyName}}</option>
            }
          </select>
        </div>
      }
    </div>
    @if (vinImages.length !== 0 && calledFrom !== 'inventoryDetail') {
      <div class="table-responsive tableFixHead">
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <td>File Name</td>
              <td>File Size</td>
              <td>VIN</td>
              <td>Year</td>
              <td>Make</td>
              <td>Model</td>
              <td>Stock Number</td>
              <td>Miles</td>
              <td>Purchase Cost</td>
              <td>Inventory Source</td>
              <td>Status</td>
              <td>VIN Image</td>
              <td>Vehicle Image(s)</td>
            </tr>
          </thead>
          <tbody>
            @for (vinImg of vinImages; track vinImg; let i = $index) {
              <tr>
                <td>{{vinImg.name}}</td>
                <td>{{vinImg.size}}</td>
                <td>{{vinImg.vinNumber}}</td>
                <td>{{vinImg.modelYear}}</td>
                <td>{{vinImg.make}}</td>
                <td>{{vinImg.model}}</td>
                <td>
                  <input (input)="changeStockNumber(vinImg)" id="stockNumber_{{vinImg.imageIndex}}"
                    value="{{vinImg.stockNumber}}" type="text" class="form-control form-control-sm text-dark">
                  </td>
                  <td>
                    <input (input)="changeMiles(vinImg)" type="number" id="miles_{{vinImg.imageIndex}}"
                      value="{{vinImg.miles}}" class="form-control form-control-sm text-dark">
                    </td>
                    <td>
                      <input (input)="changeCost(vinImg)" type="number" id="cost_{{vinImg.imageIndex}}"
                        value="{{vinImg.purchaseCost}}" class="form-control form-control-sm text-dark">
                      </td>
                      <td>
                        <select id="invSrcId_{{vinImg.imageIndex}}" (change)="changeInventorySource(vinImg)"
                          value="{{vinImg.inventoryId}}" class="form-control form-control-sm text-dark">
                          <option></option>
                          @for (vendor of vendors; track vendor) {
                            <option [value]="vendor.id">
                            {{vendor.companyName}}</option>
                          }
                        </select>
                      </td>
                      <td>{{vinImg.status}}</td>
                      @if (vinImg.image) {
                        <td>
                          <img [src]="vinImg.image" alt="" id="img" height="60" width="30" class="rounded">
                        </td>
                      }
                      @if (vinImg.status === 'SUCCESS') {
                        <td colspan="2">
                          @if (vinImg.vehicleImages.length == 0) {
                            <div class="file-upload">
                              <div class="image-upload-wrap">
                                <input class="file-upload-input" type='file' accept=" .jpg, .jpeg, .heic, .heif, .png"
                                  (change)="organizeVehicleImages($event, vinImg.imageIndex)" multiple />
                                  <div class="text-center">
                                    <span class="h1 text-muted dripicons-cloud-upload"></span>
                                    <h3 class="text-muted">Drop vehicle image(s) here or click to upload vehicle
                                      image(s)
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="row">
                              @for (vehicleImg of vinImg.vehicleImages; track vehicleImg) {
                                <div class="card">
                                  <div class="card-img-top">
                                    <img [src]="vehicleImg.image" alt="" id="img" height="100" width="100"
                                      class="rounded">
                                    </div>
                                  </div>
                                }
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              <div class="modal-footer">
                @if (vinImages.length !== 0 && calledFrom !== 'inventoryDetail') {
                  <button type="button" class="btn btn-primary" (click)="saveAll()"
                    >{{words[language][
                  'save' ] }}</button>
                }
                <!-- close -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="btn-close-scan-list"
                  (click)="refreshInventoryList()">{{words[language][
                'close' ] }}</button>

              </div>
            </div>